export default __webpack_public_path__ + "static/media/photo-1517202383675-eb0a6e27775f.4457c8ec.jpeg";